import { useQuery } from '@tanstack/react-query'
import { getItem } from '../../../app/getters/getItem.js'
import { useSelector } from 'react-redux'
import {useLocation} from "react-router-dom";

export const usePlanHarmData = (rejestrId, planHarmId, enabled) => {
    const location = useLocation();
    const storedRole = useSelector((state) => state.user.role)

    const urlSegments = location.pathname.split('/').filter(Boolean);
    const roleFromUrl = urlSegments[0];

    const role = storedRole || roleFromUrl;
    const roleParam = role === 'oper' ? 'oper/' : '/'

    const wersja = planHarmId ? `/${planHarmId}` : '';
    const endpoint = `${roleParam}plan-harm/${rejestrId}${wersja}`

    return useQuery({
        queryKey: [`plan_harm_data__, rejestrId, planHarmId`],
        queryFn: async () =>
            getItem(endpoint),
        refetchOnMount: 'always',
        enabled,
    })
}
